import "./CalendarComponent.scss";
import moment, {Moment} from "moment";
import {useCallback, useEffect, useState} from "react";
import {ImageConfig} from "../../../constants";

interface CalendarComponentProps {
    minDate?: string;
    maxDate?: string;
    startDay?: string;
    disabledDates?: string [];
    selectedDate?: string;
    canSelect?: boolean;
    showControls?: boolean;
    hideDay?: boolean;
    onDateSelect?: (date: string | undefined) => void;
    onDayRender?: (date: string, dateMoment: Moment) => void;
}

const weekDays = moment.weekdays();
const months = moment.months();
const TODAY = moment();

const CalendarComponent = (props: CalendarComponentProps) => {

    const {selectedDate, onDateSelect, minDate, onDayRender, maxDate, startDay, disabledDates} = props;
    const canSelect = props.canSelect !== undefined ? props.canSelect : true;
    const [calendar, setCalendar] = useState<any>(null);
    const [tmpSelectedDate, setTmpSelectedDate] = useState<string | undefined>(selectedDate);

    const build = useCallback((date: Moment = moment()) => {
            console.log('building...');
            const dates: any = {};
            const currentInstanceStart = date.clone();
            const monthStart = date.clone();
            const monthEnd = date.clone();
            const tmpToday = TODAY.clone().format('YYYY-MM-DD');
            monthStart.startOf('month');
            monthEnd.endOf('month');
            const currentMonthStart = monthStart.clone();
            const currentMonthEnd = monthEnd.clone();
            const start = monthStart.date();
            const end = monthEnd.date();
            const month = date.month();
            const currentYear = date.year();
            const currentMonth = month;
            // weekRows = Array(Math.ceil(end / 7)).fill(0).map((x, i) => i);
            const year = date.year();
            let weekNumber = 1;
            const weekRows: number[] = [weekNumber];
            let dayNumber = 1;
            const tmpMinDate = moment(minDate || '').isValid() ? moment(minDate) : false;
            const tmpMaxDate = moment(maxDate || '').isValid() ? moment(maxDate) : false;
            for (let day = start; day <= end; day++) {
                const dateString = year + '-' + (((month + 1) < 10) ? '0' : '') + (month + 1) + '-' + ((day < 10) ? '0' : '') + day;
                const dateItem = moment(dateString);
                const weekDay = dateItem.clone().weekday();
                // console.log(dayNumber % 7);
                if (dayNumber % 7 === 0) {
                    weekNumber++;
                    weekRows.push(weekNumber);
                }
                if (!dates[weekNumber]) {
                    dates[weekNumber] = [];
                }
                if (day === start) {
                    for (let startEmpty = 1; startEmpty < weekDay + 1; startEmpty++) {
                        // console.log(startEmpty, weekDay);
                        dates[weekNumber].push(null);
                    }
                }
                let isNotAvailable = false;
                if (tmpMinDate && tmpMaxDate) {
                    isNotAvailable = !(dateItem.unix() > tmpMinDate.unix() && dateItem.unix() < tmpMaxDate.unix());
                } else if (tmpMinDate) {
                    isNotAvailable = dateItem.unix() < tmpMinDate.unix();
                } else if (tmpMaxDate) {
                    isNotAvailable = dateItem.unix() > tmpMaxDate.unix();
                }
                dates[weekNumber].push({
                    date: dateString,
                    day: dateItem.date(),
                    dateMoment: dateItem,
                    is_today: tmpToday === dateString,
                    is_disabled: (disabledDates || []).indexOf(dateString) !== -1,
                    is_not_available: isNotAvailable
                });
                dayNumber = weekDay + 1;
                if (day === end) {
                    for (let endEmpty = weekDay + 1; endEmpty < 7; endEmpty++) {
                        dates[weekNumber].push(null);
                    }
                }
            }
            setCalendar({
                dates,
                currentInstanceStart,
                currentMonthStart,
                currentMonthEnd,
                currentMonth,
                currentYear,
                weekRows
            })
        },
        [disabledDates, minDate, maxDate]
    );

    const getPrevMonth = useCallback((currentInstanceStart: Moment) => {
        build(currentInstanceStart.clone().add(-1, 'month'));
    }, [build])

    const getNextMonth = useCallback((currentInstanceStart: Moment) => {
        build(currentInstanceStart.clone().add(1, 'month'));
    }, [build])

    // const getToday = useCallback(() => {
    //     build(TODAY);
    // }, [build])

    // const canNavigatePrevMonth = useCallback((calendar: any, minDate?: string) => {
    //     const validMinDate = moment(minDate || '').isValid() ? moment(minDate) : false;
    //     return !validMinDate || (validMinDate && calendar?.currentMonthStart && calendar?.currentMonthStart?.unix() > validMinDate.unix());
    // }, [])
    //
    // const canNavigateNextMonth = useCallback((calendar: any, maxDate?: string) => {
    //     const validMaxDate = moment(maxDate || '').isValid() ? moment(maxDate) : false;
    //     return !validMaxDate || (validMaxDate && calendar?.currentMonthEnd && calendar?.currentMonthEnd?.unix() < validMaxDate.unix());
    // }, [])

    const datesSelected = useCallback((date: string | undefined) => {
        if (onDateSelect) {
            onDateSelect(date);
        }
    }, [onDateSelect]);

    useEffect(() => {
        // console.log('selectedDates changed', selectedDates);
        setTmpSelectedDate(selectedDate);
    }, [selectedDate]);

    const daySelect = useCallback((date: string) => {
        if (canSelect) {
            if (tmpSelectedDate === date) {
                setTmpSelectedDate(undefined);
                datesSelected(undefined);
            } else {
                setTmpSelectedDate(date);
                datesSelected(date);
            }
        }
    }, [canSelect, tmpSelectedDate, datesSelected])


    useEffect(() => {
        const validStartDay = moment(startDay || '').isValid() ? moment(startDay) : false;
        if (validStartDay) {
            build(validStartDay);
        } else {
            build();
        }
    }, [build, startDay]);

    return (
        <div className={'calendar-component'}>
            <>{calendar &&
                <div className="ts-calendar-wrapper">
                    <div className="ts-calendar-controls">
                        <div className="ts-calendar-month-year-title">
                            <span>{!!months && calendar?.currentMonth !== undefined && months[calendar.currentMonth]}</span>&nbsp;{calendar?.currentYear}
                        </div>
                        <div className="ts-calendar-nav-controls">
                            <ImageConfig.NavBack className={'icon-button'}
                                // disabled={!canNavigatePrevMonth(calendar, minDate)}
                                                 onClick={getPrevMonth.bind(null, calendar.currentInstanceStart)}/>
                            <ImageConfig.NavNext className={'icon-button'}
                                // disabled={!canNavigatePrevMonth(calendar, minDate)}
                                                 onClick={getNextMonth.bind(null, calendar.currentInstanceStart)}/>
                        </div>

                    </div>
                    <div className="ts-calendar-weeks">
                        {weekDays && weekDays.map((dayName, index) => {
                            return (
                                <div className={"ts-week-name-item ts-week-day-" + index} key={'week-' + index}>
                                    {dayName.substring(0, 1)}
                                </div>
                            )
                        })
                        }
                    </div>
                    {
                        calendar?.weekRows && calendar?.weekRows.map((week: string | number, index: string) => {
                            const weekNullDaysCount = calendar?.dates[week].filter((day: any) => day === null)?.length;
                            return (
                                <div key={'week-item-' + index} className="ts-calendar-dates">
                                    {
                                        calendar?.dates[week] && (calendar?.dates[week] || []).map((day: any, dayIndex: number) => {
                                            const nonMonthDay = +index === 0 ? calendar.currentMonthStart.clone().subtract(weekNullDaysCount - dayIndex, 'day') : calendar.currentMonthEnd.clone().add(dayIndex - (6 - weekNullDaysCount), 'day');
                                            return (
                                                <div key={'day-item-' + dayIndex}
                                                     className={`ts-day-item-wrapper ts-week-day-${dayIndex} ts-week-${week} ` + (!day ? ' ts-date-not-available' : '')}
                                                     onClick={() => {
                                                         if (canSelect && !day?.is_disabled && !day?.is_not_available) {
                                                             daySelect(day?.date)
                                                         }
                                                     }}>
                                                    {
                                                        !!day && <div
                                                            className={`ts-day-item ${day?.is_today ? ' is_today' : ''}
                                                                ${(day?.is_disabled || day?.is_not_available) ? ' disabled' : ''}
                                                                ${tmpSelectedDate && tmpSelectedDate === day?.date ? ' selected' : ''}
                                                                ${(canSelect && !day?.is_disabled && !day?.is_not_available) ? ' selectable' : ''}`}>
                                                            <>
                                                                <div className="ts-day-text">{day.day}</div>
                                                                {onDayRender && onDayRender(day.day, day.dateMoment)}
                                                            </>
                                                        </div>
                                                    }
                                                    {
                                                        !day &&
                                                        <>
                                                            <div className={"ts-day-item disabled"}>
                                                                {nonMonthDay.format('D')}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            }
            </>
        </div>
    );

};

export default CalendarComponent;
